(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-whatsapp-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('silsila-whatsapp-order')) {
  customElements.define('silsila-whatsapp-order', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.variants = JSON.parse(this.querySelector('[data-whatsapp-variants]').textContent);
      this.optionNames = JSON.parse(this.querySelector('[data-whatsapp-options]').textContent);
      this.scope = this.closest('product-info') || this.closest('.shopify-section');
      this.update = () => {
        const picker = this.scope.querySelector('variant-radios, variant-selects');
        const selected = picker ? [...picker.querySelectorAll('[data-option-index]')].map(group => group.querySelector('input[type="radio"]:checked, select')?.value) : [];
        const id = this.scope.querySelector('product-form input[name="id"]')?.value;
        const variant = selected.length ? this.variants.find(v => v.options.length === selected.length && v.options.every((option, i) => option === selected[i])) : this.variants.find(v => String(v.id) === String(id));
        if (!variant) { this.link.removeAttribute('href'); this.link.setAttribute('aria-disabled', 'true'); return; }
        const quantity = this.scope.querySelector('input[name="quantity"]')?.value || '1';
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variant.id);
        const lines = [`${this.dataset.intro} ${this.dataset.productTitle}`, ...variant.options.map((value,i) => `${this.optionNames[i]}: ${value}`), `${this.dataset.quantityLabel}: ${quantity}`, url.href];
        this.link.href = `https://wa.me/923032536799?text=${encodeURIComponent(lines.join('\n'))}`;
        this.link.removeAttribute('aria-disabled');
      };
      this.scope.addEventListener('change', this.update);
      this.scope.addEventListener('input', this.update);
      this.link.addEventListener('pointerdown', this.update);
      this.link.addEventListener('click', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.update);
      this.scope?.removeEventListener('input', this.update);
      this.link?.removeEventListener('pointerdown', this.update);
      this.link?.removeEventListener('click', this.update);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
